import { useContext } from "react";

import { themeSizes } from "theme";
import { widthBySize } from "theme/constants";

import FnrTypography from "FnrTypography";

import FnrChevron from "UI/FnrChevron";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import Amount from "./Amount";
import DeleteButton from "./DeleteButton";
import { EditorContext } from "./Editor";
import FlexSwitch from "./FlexSwitch";

const accordionLabelInnerGap = 8;
const iconSize = themeSizes.sm;
const accordionLabelIconWidth = widthBySize[iconSize];

const AccordionLabel = () => {
  const { icon, title, active, horizontal } = useContext(EditorContext);

  return (
    <FlexSwitch horizontal={horizontal}>
      <FnrHorizontalGap gap={accordionLabelInnerGap}>
        <FnrContainedIcon size={iconSize} icon={icon} />
        <FnrTypography fontSize="lg">{title}</FnrTypography>
        <FnrChevron active={active} />
      </FnrHorizontalGap>
      <FnrHorizontalGap gap={4} justifyContent="flex-end">
        <DeleteButton />
        <Amount />
      </FnrHorizontalGap>
    </FlexSwitch>
  );
};

export { accordionLabelInnerGap, accordionLabelIconWidth };
export default AccordionLabel;
